import { useQuery } from '@tanstack/react-query';

import { APIResponse } from 'api';
import { EngagementHeatmapData } from 'models';

export default function useEngagementHeatmap(engagementId: string) {
  const path = `/plugins/vdp/velocityengage/engagement/${engagementId}/heatmapData`;
  return useQuery<APIResponse<EngagementHeatmapData>>([path]);
}
